import {HttpClient} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Injectable({providedIn: 'root'})
export class SubscriptionService {
  private httpClient = inject(HttpClient);


  cancel(): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.apiUrl}/companies/subscription/cancel`,
      {}
    );
  }

  restore(): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.apiUrl}/companies/subscription/restore`,
      {}
    );
  }
}
